<template>
    <v-app>
        <v-navigation-drawer v-model="drawer" permanent light app>
            <v-list-item>
                <v-list-item-content>
                    <v-list-item-title class="title">
                        Octopus - Help Center
                    </v-list-item-title>
                    <v-list-item-subtitle>
                        Panel de Administración
                    </v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>

            <v-divider/>

            <v-list>
                <v-list-item color="primary" v-for="item in items" :key="item.title" :to="item.route">
                    <v-list-item-icon>
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>

            <template v-slot:append>
                <div class="pa-2">
                    <v-btn block color="primary" to="/" class="mb-1">Ir al Front</v-btn>
                    <v-btn block color="secondary" @click="logout">Cerrar Sesión</v-btn>
                </div>
            </template>
        </v-navigation-drawer>

        <v-content>
            <v-container>
                <v-row>
                    <v-col cols="12">
                        <slot/>
                    </v-col>
                </v-row>
            </v-container>
        </v-content>

    </v-app>
</template>

<script>
  export default {
    name: 'Backend',
    props: ['loading'],
    data() {
      return {
        drawer: true,
        items: [
          {route: '/admin/posts', title: 'Posts', icon: 'mdi-file-code-outline'},
          {route: '/admin/categories', title: 'Categorias', icon: 'mdi-chart-timeline'},
          {route: '/admin/order', title: 'Cambiar Orden', icon: 'mdi-arrow-split-horizontal'},
        ],
      };
    },
    methods: {
      logout() {
        this.$store.dispatch('logout');
        this.$router.push('/');
      },
    },
  };
</script>

<style scoped>

</style>